export const OrderSteps = {
  SELECT_LOCATION: {
    step: 1,
    text: 'select location',
    view: 'SelectLocation',
    aliasViews: [],
    showOnProgressBar: true,
    hideCart: true,
    hideCartIfEmpty: true,
    hideUserLocationComponent: true,
    hideBackButton: true,
  },
  CHOOSE_FOOD: {
    step: 2,
    text: 'choose food',
    view: 'ChooseFood',
    aliasViews: ['ChooseFoodCategory', 'ProductAdd', 'ProductEdit'],
    showOnProgressBar: true,
    hideCartIfEmpty: true,
  },
  ORDER_SUMMARY: {
    step: 3,
    text: 'order summary',
    view: 'OrderSummary',
    aliasViews: ['OrderSummary', 'OrderSummaryNaked'],
    hideCart: true,
    showOnProgressBar: true,
  },
  CHECKOUT: {
    step: 4,
    text: 'checkout',
    view: 'Checkout',
    aliasViews: [],
    hideCart: true,
    hideProgressBar: true,
    hideUserLocationComponent: true,
    showOnProgressBar: true,
    hideBackButton: true,
  },
  ORDER_CONFIRMATION: {
    step: 5,
    text: 'order confirmation',
    view: 'OrderConfirmation',
    aliasViews: [],
    hideCart: true,
    hideProgressBar: true,
    hideUserLocationComponent: true,
    showOnProgressBar: true,
    hideBackButton: true,
  },
}

export enum Views {
  SELECT_LOCATION ='SelectLocation',
  CHOOSE_FOOD ='ChooseFood',
  CHOOSE_FOOD_CATEGORY ='ChooseFoodCategory',
  PRODUCT_ADD ='ProductAdd',
  PRODUCT_EDIT ='ProductEdit',
  ORDER_SUMMARY ='OrderSummary',
  ORDER_SUMMARY_NAKED ='OrderSummaryNaked',
  CHECKOUT ='Checkout',
  ORDER_CONFIRMATION ='OrderConfirmation',
  ORDER_HISTORY ='OrderHistory',
  FAVORITE_LOCATIONS ='FavoriteLocations',
  REWARDS ='Rewards',
  REWARD_HISTORY ='RewardHistory',
  CONTACT_US_FORM = 'ContactUsForm',
  FREE_SUBS_FORM = 'FreeSubsForm',
  SWEEPSTAKES_FORM = 'SweepstakesForm',
  FOUNDATION_APPLICATION_FORM = 'FoundationApplicationForm',
  WSA_FORM = 'WSAForm',
  APPLE_DEVELOPER_VERIFICATION = 'AppleDeveloperVerification'
}

export enum MutationTypes {
  SET_RESTAURANTS = 'setRestaurants',
  SET_MENU = 'setMenu',
  SET_HOURS = 'setHours',
  SET_ACTIVE_CATEGORY = 'setActiveCategory',
  SET_ACTIVE_PRODUCT = 'setActiveProduct',
  SET_ACTIVE_PRODUCT_MODIFIERS = 'setActiveProductModifiers',
  SET_ACTIVE_RESTAURANT = 'setActiveRestaurant',
  SET_ACTIVE_REGION_ID = 'setActiveRegionId',
  SET_EDIT_IS_OPEN = 'setEditIsOpen',
  STORE_PRODUCT_MODIFIERS = 'storeProductModifiers',
  SET_UPSELL_ITEMS = 'setUpsellItems',
  SET_HAS_BEEN_UPSOLD = 'setHasBeenUpsold',
  SET_PREVIEW_LOCATION = 'setPreviewLocation',
  CLEAR_PRODUCT_MODIFIER_CACHE = 'clearProductModifierCache',
}

export enum END_POINTS {
  USERS = 'user',
  RESTAURANTS = 'restaurant',
  PRODUCTS = 'product',
  BASKETS = 'basket',
  ORDERS = 'order',
  FORMS = 'form',
  EVENTS = 'event',
}

export enum OrderMethods {
  PICKUP = 'pickup',
  CURBSIDE = 'curbside',
  DELIVERY = 'delivery',
  DISPATCH = 'dispatch',
}

export enum TimeModes {
  ASAP = 'asap',
  ADVANCE = 'advance',
}

// Enum: "creditcard" (Entered credit card) "billingaccount" (Saved credit card) "storedvalue" (Gift card)
export enum BillingMethod {
  creditcard = 'creditcard',
  billingaccount = 'billingaccount',
  storedvalue = 'storedvalue',
  creditcardtoken = 'creditcardtoken',
  digitalwallet = 'digitalwallet'
}

export enum MetaKeys {
  navigationSelectable = 'NavigationSelectable',
  displayOptionGroupName = 'display-option-group-name',
}

export enum MetaValues {
  empty = '',
  true = 'true',
}

export const PaymentMethods = {
  AS_GUEST: { text: 'Guest Checkout', value: '1' },
  LOGGED_IN: { text: 'Login', value: '2' },
  CREATE_ACCOUNT: { text: 'Register', value: '3' },
}

export const VUEX_KEY = 'csoa_vuex';

export const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  // eslint-disable-next-line
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  // eslint-disable-next-line
  administrative_area_level_1: 'short_name',
  // eslint-disable-next-line
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  // eslint-disable-next-line
  postal_code: 'short_name',
};
export const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
export const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2',
];
/*
  By default, we're only including basic place data because requesting these
  fields place data is not additionally charged by Google. Please refer to:
  https://developers.google.com/maps/billing/understanding-cost-of-use#basic-data
*/
export const BASIC_DATA_FIELDS = [
  'address_components', 'adr_address', 'alt_id', 'formatted_address',
  'geometry', 'icon', 'id', 'name', 'business_status', 'photo', 'place_id',
  'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity',
];
